import "./Title.scss";

const Title = ({text}) => {

    return (
        <div className="title" >{text}</div>
    );
}

export {Title};